// Zip entry names collide silently: JSZip's folder.file(name, blob) has
// map-put semantics, so a second entry with the same name replaces the first
// and the archive quietly comes out a file short. Same-named uploads are
// legitimate on the platform (blobs are id-keyed precisely so they can
// coexist), so bulk downloads dedupe Windows-style: the first file keeps its
// name, later duplicates get " (1)", " (2)", ... before the extension.
//
// Create one allocator per zip folder — folders are separate namespaces.
export function makeZipNameAllocator() {
  const used = new Set();
  return (name) => {
    const base = name || 'file';
    if (!used.has(base)) {
      used.add(base);
      return base;
    }
    const dot = base.lastIndexOf('.');
    const stem = dot > 0 ? base.slice(0, dot) : base;
    const ext = dot > 0 ? base.slice(dot) : '';
    let counter = 1;
    let candidate = `${stem} (${counter})${ext}`;
    while (used.has(candidate)) {
      counter += 1;
      candidate = `${stem} (${counter})${ext}`;
    }
    used.add(candidate);
    return candidate;
  };
}
